module.exports = __webpack_public_path__ + "media/metronic/_theme/media/client-logos/logo4-543743ea9e063449e6162bf13fe746dc.png";